import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";

import Skeleton from "ui/Skeleton";
import Tooltip from "@mui/material/Tooltip";
import MuiTypography from "@mui/material/Typography";

function Typography(props) {
  const {
    children,
    isLoading = false,
    withTooltip = false,
    loadingWidth = 210,
    loadingVariant = "rectangular",
    ...otherProps
  } = props;

  const [isOverflowed, setIsOverflow] = useState(false);
  const textElementRef = useRef();

  useEffect(() => {
    if (!withTooltip) return;
    setIsOverflow(
      textElementRef.current.scrollWidth > textElementRef.current.clientWidth,
    );
  }, []);

  const renderChildren = () => {
    if (isLoading) {
      return <Skeleton width={loadingWidth} variant={loadingVariant} />;
    }

    return children;
  };

  return (
    <Tooltip
      title={children}
      disableHoverListener={!isOverflowed}
      placement="bottom"
    >
      <MuiTypography {...otherProps} ref={textElementRef}>
        {renderChildren()}
      </MuiTypography>
    </Tooltip>
  );
}

export const TypographyPropTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  isLoading: PropTypes.bool,
  variant: PropTypes.string,
  children: PropTypes.any,
  loadingWidth: PropTypes.number,
  loadingVariant: PropTypes.string,
  align: PropTypes.string,
  onClick: PropTypes.func,
  withTooltip: PropTypes.bool,
};

Typography.propTypes = TypographyPropTypes;

export default Typography;
